module.exports = __webpack_public_path__ + "assets/images/f33512e165b2de4fb3b71f9554a734f4.png";